import { createStateContext } from '@change-corgi/core/react/context';

import type { InitialStateParams } from './initialState';
import { initialState } from './initialState';
import { mutations } from './mutations';
import type { PromoteFormState } from './types';

export const {
	StateContext: PromoteFormStateContext,
	StateProvider: PromoteFormStateContextProvider,
	useStateContext: usePromoteFormState,
} = createStateContext<PromoteFormState, typeof mutations, InitialStateParams>({
	name: 'PromoteFormStateContext',
	mutations,
	initialState,
});
